export enum ANNOTATION_CATEGORY {
    HOME = 1,
    WORK = 2,
    OTHER = 3,
    FRIENDS_AND_FAMILY = 4,
}

export enum ANNOTATION_TYPES {
    HOME = "Home",
    WORK = "Work",
    OTHER = "Other",
    FRIENDS_AND_FAMILY = "Friends and Family",
}

export enum ANNOTATION_ASSETS {
    HOME = "img_0.png",
    WORK = "work.png",
    OTHER = "others.png",
    FRIENDS_AND_FAMILY = "family_friends.png",
    STATIC = "img_1.png",
}

export interface DeliveryAddress {
    id: string;
    version: number;
    name: string;
    addressLine1: string;
    addressLine2: string;
    address: string;
    landmark: string;
    area: string;
    mobile: string;
    alternateMobile: string;
    annotation: string;
    instructions: string;
    email: string;
    flatNo: string;
    city: string;
    lat: string;
    lng: string;
    isVerified: boolean;
    addressCategory: number;
    userIntentAddressCategory?: number;
}

export const ADDRESS_CATEGORIES = {
    ADDRESS_CATEGORY_INVALID: 0,
    ADDRESS_CATEGORY_HOME: 1,
    ADDRESS_CATEGORY_WORK: 2,
    ADDRESS_CATEGORY_OTHER: 3,
    ADDRESS_CATEGORY_FRIENDS_AND_FAMILY: 4,
};
